import React, { type ReactNode } from 'react';

import { AnalyticsContext } from '@atlaskit/analytics-next';

import {
	type SearchAIAnalyticsContextDataInput,
	sanitizeSearchAIAnalyticsContextData,
} from './analytics-helpers';

export type SearchAIAnalyticsContextProps = {
	/** Raw context payload; unknown attribute keys are dropped via {@link sanitizeSearchAIAnalyticsContextData}. */
	data: SearchAIAnalyticsContextDataInput;
	children: ReactNode;
};

/**
 * Wraps `AnalyticsContext` for SAIN / Search AI answer subtrees. Pass whatever you have on `data`;
 * {@link sanitizeSearchAIAnalyticsContextData} drops keys not on the Search AI analytics allowlist.
 */
export function SearchAIAnalyticsContext({
	data,
	children,
}: SearchAIAnalyticsContextProps): React.JSX.Element {
	const value = sanitizeSearchAIAnalyticsContextData(data);
	return <AnalyticsContext data={value}>{children}</AnalyticsContext>;
}
